import React from "react";
import { Button, Modal } from "react-bootstrap";
import { LVLHEALTH, LVL_HEALTH_LABEL } from "../../app/utils/Constants";

const HomeHealthHeader = (props) => {
  const { mode, error, cloneIsEnabled, reactToPrintFn, partnerOrderId, has_print_option } = props;

  const pageLabel = window.location.pathname === LVLHEALTH ? LVL_HEALTH_LABEL : "Care at Home";

  return (
    <React.Fragment>
      <React.Fragment>
        <Modal.Title
          data-testid={`time-draw-modal-header-${mode}`}
          className="headline4"
        >
          {" "}
          {mode === "view"
            ? `View ${pageLabel}`
            : mode === "create"
            ? cloneIsEnabled
              ? "Cloned Order"
              : "Create Order"
            : `Edit ${pageLabel}`}
        </Modal.Title>
        {mode === 'view' && has_print_option && <Button
          data-testid="time-draw-button-view"
          className="primary-btn plain-btn d-flex align-items-center btn-border-right btn-print"
          onClick={reactToPrintFn}
        >
          <span className="print-icon pe-1 pt-1">
            <span className="visually-hidden">print-icon</span>
          </span>
          <span>Print</span>
        </Button>}
        {error && (
          <p
            className="error-message-alert"
            data-testid="time-draw-modal-header-create-error"
          >
            {error}
          </p>
        )}
      </React.Fragment>
    </React.Fragment>
  );
};

export default HomeHealthHeader;
